import { render, staticRenderFns } from "./cambioPassword.vue?vue&type=template&id=11f9e7a2"
import script from "./cambioPassword.vue?vue&type=script&lang=js"
export * from "./cambioPassword.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports